import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonEn from "./en/commonEn";
import dashboardEn from "./en/dashboardEn";
import plansEn from "./en/plansEn";
import paymentsEn from "./en/paymentsEn";
import customerEn from "./en/customerEn";

const resources = {
    en: {
        translation: {
            ...commonEn,
            ...dashboardEn,
            ...plansEn,
            ...paymentsEn,
            ...customerEn,
        }
    },
};

// Initialize i18next
i18n.use(initReactI18next).init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: { escapeValue: false }
});

export default i18n;
